import Vue from "vue";
import VueRouter from "vue-router";

import LoginView from "@/components/pages/LoginView.vue";
import RegisterComponent from "@/components/utils/RegisterComponent.vue";
import Armarios from "@/components/pages/Armarios.vue";
import SoloPlanos from "@/components/pages/SoloPlanos.vue";



//sin permisos
import SinPermisos from '@/components/pages/views/SinPermisosView.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/sin-permiso",
    name: "sin-permiso",
    component: SinPermisos,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Sin permisos",
          content: "Sin permisos en " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/planos",
    name: "planos",
    component: SoloPlanos,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Página planos",
          content: "Página planos de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: {
      hideClientSelector: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Login",
          content: "Página de Login del portal de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/register",
    name: "register",
    component: RegisterComponent,
    meta: {
      hideClientSelector: true,
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Registro",
          content: "Página de Registro del portal de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/armarios",
    name: "cabinets",
    component: Armarios,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "cabinets",
          content: "Lista de armarios de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/",
    name: "home",
    // path: "/parts",
    // name: "parts",
    component: Armarios,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Partes",
          content: "Lista de partes de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = `${to.meta.title} - ${to.meta.metaTags[0].name}`;
//   }
//   const loggedIn = localStorage.getItem("token");
//   if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
//     next({name: "login"});
//   }
//   else {
//     next();
//   }
// });
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - ${to.meta.metaTags[0].name}`;
  }

  const loggedIn = !!localStorage.getItem("token");

  // Redirigir al home si está logueado y quiere ir al login
  if (loggedIn && to.name === "login") {
    return next({ name: "home" });
  }

  // Si no está logueado y la ruta requiere auth → login
  if (!loggedIn && to.matched.some(r => r.meta.requiresAuth)) {
    next({ name: 'login', query: to.query });
  }

  next();
});




export default router;
